RA.TrendingQuestions = {
  init() {
    let url;

    url = Config.contextPath + "/controller/socialsearch/trending/";
    $.get(url)
      .done(this.trendingQuestionsDone)
      .fail(RA.handleAjaxError);
  },
  trendingQuestionsDone(r) {
    let component;

    if (r.results.length) {
      component = (
        <CommResultsList showIcon={false}
          hits={r.results} />
      )
    } else {
      component = <NoContent message={Labels.getLabel("Nothing trending right now")} />;
    }

    ReactDOM.render(component, document.getElementById("trendingQuestions"));
  }
}